<template>
  <td class="border-neutral-light-5 p-2 text-xs">
    <slot />
  </td>
</template>
